import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import AdminList from './AdminList'
import {
  allCrudNames,
  allPages,
  checkPageAccess
} from '../../../lib/AllPageNames'
import NotFound from '../../NotFound/NotFound'

const ManageAdminTabbing = () => {
  const [activeToggle, setActiveToggle] = useState('admin')

  const { pageAccess } = useSelector((state) => state.user)
  const handleTabClick = (e, tabName) => {
    e.preventDefault()
    setActiveToggle(tabName)
  }

  return checkPageAccess(
    pageAccess,
    allPages?.manageAdmin,
    allCrudNames?.read
  ) ? (
    <>
      {checkPageAccess(
        pageAccess,
        allPages?.manageAdmin,
        allCrudNames?.read
      ) && (
        <div className='card overflow-hidden'>
          <div className='card-body p-0'>
            <div className='nav-tabs-horizontal nav nav-tabs'>
              <Link
                onClick={(e) => handleTabClick(e, 'admin')}
                data-toggle='tab'
                className={`nav-link fw-semibold ${
                  activeToggle === 'admin' ? 'active show' : ''
                }`}
              >
                <span className='nav-span'>
                  Admin
                  <hr />
                </span>
              </Link>
            </div>

            <div className='tab-content p-3'>
              <div
                id='admin'
                className={`tab-pane fade ${
                  activeToggle === 'admin' ? 'active show' : ''
                }`}
              >
                {activeToggle === 'admin' && <AdminList />}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  ) : (
    <NotFound />
  )
}

export default ManageAdminTabbing
